// src/pages/Public/LandingPage/v2/hooks/useLandingScroll.js
import { useCallback, useEffect, useMemo, useState } from "react";

/**
 * Hook de scroll para landing con HashRouter:
 * - No usa anchors #id (porque romperían rutas con HashRouter)
 * - Hace scroll suave por JS a secciones por id
 */
export function useLandingScroll(options = {}) {
  const {
    scrolledThreshold = 16,
    showScrollTopThreshold = 600,
    headerOffset = 84, // ajustable (alto navbar)
  } = options;

  const [scrolled, setScrolled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || 0;
      setScrolled(y > scrolledThreshold);
      setShowScrollTop(y > showScrollTopThreshold);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrolledThreshold, showScrollTopThreshold]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const scrollToId = useCallback(
    (id) => {
      if (!id) return;

      const el = document.getElementById(id);
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const top = rect.top + (window.scrollY || 0) - headerOffset;

      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    },
    [headerOffset],
  );

  return useMemo(
    () => ({
      scrolled,
      showScrollTop,
      scrollToTop,
      scrollToId,
    }),
    [scrolled, showScrollTop, scrollToTop, scrollToId],
  );
}
